import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { ApolloError } from "@outschool/ui-apollo";
import React from "react";
import { useParams } from "react-router-dom";

import { useClassDetails } from "./useClassDetails";

type ClassDetailsActivity = ClassDetailsNoSectionsQuery["activity"];

type Context = {
  activity: ClassDetailsActivity | undefined;
  error: ApolloError | undefined;
  loading: boolean;
};

const ActivityDetailPageContext = React.createContext<Context>({
  activity: undefined,
  error: undefined,
  loading: true,
  // @ts-ignore TS(2322): Type 'undefined' is not assignable to type 'Exact<... Remove this comment to see the full error message
  variables: undefined
});

export const ActivityDetailPageProvider: React.FC<
  React.PropsWithChildren<{}>
> = ({ children }) => {
  const params = useParams<{
    activitySlugOrUid: string;
  }>();
  const { activity, loading, error } = useClassDetails(
    params.activitySlugOrUid
  );

  return (
    <ActivityDetailPageContext.Provider
      value={{
        activity,
        error,
        loading
      }}
    >
      {children}
    </ActivityDetailPageContext.Provider>
  );
};

export const useActivityDetailPageContext = () => {
  return React.useContext(ActivityDetailPageContext);
};
